import { Action } from 'redux';

export interface AlertState {
  alertType?: 'info' | 'warning' | 'error' | 'success';
  message?: string;
  alertsWithId: { [x: string]: AlertState };
}

const reducer = (
  state: AlertState = { alertsWithId: {} },
  action: Action & AlertState & { id: string }
): AlertState => {
  const { type, id, ...newState } = action;
  switch (type) {
    case 'SET_ALERT_STATE':
      if (id) {
        return {
          ...state,
          alertsWithId: {
            ...state.alertsWithId,
            [id]: newState
          }
        };
      }
      return { ...state, ...newState };
    default:
      return state;
  }
};

export default reducer;
